var e={container:"UiCollapsible-module_container__4H8NT",header:"UiCollapsible-module_header__t-b50",opened:"UiCollapsible-module_opened__tBlAb"};export{e as default};
//# sourceMappingURL=UiCollapsible.module.scss.js.map
